'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _keyPaths = require('../constants/keyPaths');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _keyPaths.UPDATE_TYPE, null), _defineProperty(_Record, 'pipelineId', null), _defineProperty(_Record, 'pipelineName', null), _defineProperty(_Record, 'pipelineStageId', null), _defineProperty(_Record, 'pipelineStage', null), _Record), 'TicketUpdateMeta');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/crm-object-lifecycle-update/records/TicketUpdateMetadata.js
// module id = 751
// module chunks = 2 3